import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

//import services
import { SettingsService } from '../../../../services/settings.service';
import { GeneralService } from '../../../../services/general.service';

//import constants
import { AppFrontRoutes } from '../../../../constants/app-front-routes';

@Component({
  selector: 'app-sub-settings',
  templateUrl: './sub-settings.component.html',
  styleUrls: ['./sub-settings.component.css']
})
export class SubSettingsComponent implements OnInit {

  settingsForm: FormGroup;
  settingsFormEdit: Boolean = false;

  details: any;
  timezoneConfig: any;
  editLang: any;
  editResp: any;

  constructor(
    private route: ActivatedRoute,
    private settingsService: SettingsService,
    private generalService: GeneralService,
    private formBuilder: FormBuilder,
    private router: Router,
  ) { }

  ngOnInit() {

    //fetch data from service
    this.details = this.route.snapshot.data['data'];
    this.timezoneConfig = this.details.data.settingsData.timezones;

    this.editLang = this.settingsService.getSettingsLang(this.details);
    this.editResp = this.details.data.settingsData;

    this.FormBuild();

  }

  FormBuild(): void {

    this.settingsForm = this.formBuilder.group({
      lang_val: [this.editResp.lang_val],
      timezone: [this.editResp.timezone],
      action: 'timezone_save',
    });

    this.settingsForm.disable();

  }

  settingsFormEditEnable(): void {
    
    this.settingsFormEdit = true;
    this.settingsForm.enable();

  }

  settingsFormSubmit(): void {

    this.settingsService.settingsUpdate(this.settingsForm.value)
      .subscribe(
        (res) => {

          if (res.status) {
            localStorage.setItem('lang', res.lang);
            this.generalService.notify_msg('success', res.msg);
            this.router.navigateByUrl('/test', { skipLocationChange: true })
              .then(() => {
                this.router.navigate([AppFrontRoutes.SETTINGS, { tab: 2 }]);
            });
          }
          else
            this.generalService.notify_msg('error', res.msg);
        }
      );



  }

}
